import { apiUrl, httpClient } from "@/utilities";
import { DataProvider } from "react-admin";

const gameoo_resource = "bogo";

const bogoProvider: Partial<DataProvider> = {
  create: async (resource, params) => {
    if (resource !== gameoo_resource) return Promise.reject();

    const url = `${apiUrl}/${gameoo_resource}`;
    const formData = new FormData();

    // Loop through fields and append to formData
    for (const key in params.data) {
      const value = params.data[key];

      if (key === "file" && value?.rawFile) {
        formData.append("file", value.rawFile);
      } else if (key === "day_validity" && Array.isArray(value)) {
        for (const day of value) {
          formData.append("day_validity[]", day);
        }
      } else {
        formData.append(key, value);
      }
    }
    const response = await httpClient(url, {
      method: "POST",
      body: formData,
    });

    return { data: response.json };
  },

  update: async (resource, params) => {
    if (resource !== gameoo_resource) return Promise.reject();

    const url = `${apiUrl}/${gameoo_resource}/${params.id}`;
    const response = await httpClient(url, {
      method: "PATCH",
      body: JSON.stringify(params.data),
    });

    return { data: response.json };
  },
};

export default bogoProvider;
